import regEmoji from 'emojibase-regex';
import regEmoticon from 'emojibase-regex/emoticon';
import regShortcode from 'emojibase-regex/shortcode';
import tryRegExp from '~/tryRegExp';

export const regEmojis = new RegExp(regEmoji, 'g');

const regEmoticonString = regEmoticon
  .toString()
  // Strip off the regex delimiters and require the preceding character to be the start of the string or a space.
  .replace(/^\//, '(?<=(^|\\s))(')
  // add in the `xP` emoticon and require a the following character to be a space or the end of the string.
  .replace(/\/$/, '|xP)(?=(\\s|$))');
export const regEmoticons = tryRegExp(regEmoticonString, 'g') ?? regEmoticon;

const regShortcodeString = regShortcode
  .toString()
  // Strip off the regex delimiters and create a match group to contain the text between the colons.
  .replace(/^\/:/, ':(')
  .replace(/:\/$/, '):');
export const regShortcodes = tryRegExp(regShortcodeString, 'g') ?? regShortcode;
